export default {
  bestTimeToSell: {
    id: 'buyback_offer_graph_best_time_to_sell',
    defaultMessage: 'Best time to sell',
  },
  now: {
    id: 'buyback_offer_graph_now',
    defaultMessage: 'Now',
  },
  oneMonth: {
    id: 'buyback_offer_graph_one_month',
    defaultMessage: '1 month',
  },
  threeMonths: {
    id: 'buyback_offer_graph_three_months',
    defaultMessage: '3 months',
  },
  sixMonths: {
    id: 'buyback_offer_graph_six_months',
    defaultMessage: '6 months',
  },
  tradeInValue: {
    id: 'buyback_offer_graph_trade_in_value',
    defaultMessage: '{product} trade-in value',
  },
  tradeInValueEstimate: {
    id: 'buyback_offer_graph_trade_in_value_estimate',
    defaultMessage: '{product} trade-in value estimates',
  },
  disclaimer: {
    id: 'buyback_offer_graph_disclaimer',
    defaultMessage: '*Future values are estimates and may vary over time.',
  },
}
